<div class="layout-breadcrumb">
    <div class="breadcrumb">
        <div class="route-bar-breadcrumb">
                <ng-template ngFor let-item let-last="last" [ngForOf]="items">
                    <li>
                        <a [routerLink]="item?.routerLink" *ngIf="item?.routerLink">{{item?.label}}</a>
                        <ng-container *ngIf="!item?.routerLink">{{item?.label}}</ng-container>
                    </li>
                    <li *ngIf="!last"><i class="pi pi-angle-right"></i></li>
                </ng-template>
        </div>
    </div>

    <div class="breadcrumb-actions">
        <div class="yape-access-wrapper" *ngIf="(companySelected$ | async)?.verNotificacionYape === true">
            <a class="yape-access"
               routerLink="/pagos-yape"
               routerLinkActive="is-active"
               pTooltip="Ver pagos Yape"
               tooltipPosition="bottom"
               aria-label="Ver pagos Yape">
                <img src="assets/static/yape.png" alt="">
            </a>
            <app-notification-count-badge
                class="yape-notification-badge"
                [notificationTypes]="yapeNotificationTypes">
            </app-notification-count-badge>
        </div>
        <app-network-indicator></app-network-indicator>
    </div>
</div>

<app-activation-notice *ngIf="!appMain?.esProduccion"></app-activation-notice>
